/**
 * This custom hook provides the functionality to retrieve users to be shown in the UI.
 */

import {useContext} from "react";
import {useSnackbar} from "notistack";
import {useIntl} from "react-intl";
import {FirebaseAuthContext} from "../../../../../commons/firebase/FirebaseAuthProvider";

const useFetchAdminDashboardData = () => {
    const {signedInUser} = useContext(FirebaseAuthContext);
    const {enqueueSnackbar} = useSnackbar();

    // Internationalization for simple strings
    const intl = useIntl();

    // Retrieving the dashboard data for administrators
    const fetchAdminDashboardData = async (association, fromDate, toDate) => {
        const idToken = await signedInUser.getIdToken()

        // Prepare the dates in UTC timestamp, so that they are comparable globally
        let fromDateBeginOfDay = new Date(Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), 0, 0, 0, 0))
        let toDateEndOfDay = new Date(Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), 23, 59, 59, 999))

        return fetch('/reg-main/dashboard/admin' +
            '?idToken=' + idToken +
            '&associationFilter=' + JSON.stringify(association) +
            '&fromDateFilter=' + JSON.stringify(fromDateBeginOfDay) +
            '&toDateFilter=' + JSON.stringify(toDateEndOfDay)
        ).then(async (data) => {
            // Throw an error including the textual status of the HTTP response code (no detailed message necessary)
            if (data.status !== 200) {
                throw new Error((await data.json()).status)
            }

            return data.json();
        }).catch((error) => {
            enqueueSnackbar(
                intl.formatMessage({
                    id: 'app.dashboard.messages.load.dashboardData.error',
                    defaultMessage: 'Something went wrong while loading the dashboard data: {error}'
                }, {error: error.message}), {
                    variant: 'error',
                    preventDuplicate: true,
                    autoHideDuration: 5000
                });
        })
    }

    return {
        fetchAdminDashboardData
    }
}
export default useFetchAdminDashboardData;